// extracted by css-extract-rspack-plugin
export default {"editor_table":"N34k7NtM5koNoUnu"};